export const ALL_APPLICABLE_MAPPED_EVENTS_TYPE = 'All Applicable Mapped Events';
export const SPECIFIC_MAPPED_EVENT_TYPE = 'Specific Mapped Event...';

export const categoryMap = {
  content: 'App',
  device: 'Device',
  geo: 'Geo',
  screen: 'Screen (Mobile)',
  network: 'Network Request',
  events: 'Events',
  errors: 'Errors',
  page: 'Page (Web)',
  custom: 'Custom',
  global_tags: 'Global Tags',
  event_tags: 'Event Tags',
  campaign: 'UTM Parameters (Web)',
};

export const categoryOptions = [
  { value: 'content', label: 'App' },
  { value: 'device', label: 'Device' },
  { value: 'geo', label: 'Geo' },
  { value: 'screen', label: 'Screen (Mobile)' },
  { value: 'network', label: 'Network Request' },
  { value: 'events', label: 'Events' },
  { value: 'errors', label: 'Errors' },
  { value: 'page', label: 'Page (Web)' },
  // { value: 'custom', label: 'Custom' },
  { value: 'global_tags', label: 'Global Tags' },
  { value: 'event_tags', label: 'Event Tags' },
];
